import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { gql } from '@apollo/client';
import client from '../../graphqlClient';

const CustomerReview = () => {
  const [imageSources, setImageSources] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await client.query({
          query: gql`
            {
              cmsBlocks(identifiers: ["home_testimonials"]) {
                items {
                  identifier
                  title
                  content
                }
              }
            }
          `,
        });

        const html = data.cmsBlocks.items[0].content;
        const tempElement = document.createElement('div');
        tempElement.innerHTML = html;

        const customerCols = tempElement.querySelectorAll('.review-row');
        const sources = Array.from(customerCols).map((col) => {
          const content = col.querySelector('.review-text p').textContent;
          const name = col.querySelector('.author-bx h6').textContent;
          return { content, name };
        });

        setImageSources(sources);
      } catch (error) {
        console.log('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const settings2 = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          slidesToShow: 1
        }
      }
    ]
  };

  return (
  <>
  {imageSources?.length > 0  && <div className="home_testimonials testimonials-section pro_testimonials">
    <h2  className='productpage_title'><span>What do our customers say...</span></h2>
    <Slider {...settings2} className="home_testimonials">
          {imageSources.map((cur, index) => (
            <div className="review-row" key={index}>
              <div className="quote-bx">
                <img src="../abddd.jpg" alt="" />
              </div>
              <div className="review-text">
                <p>{cur.content}</p>
              </div>
              <div className="author-bx">
                <h6>{cur.name}</h6>
              </div>
            </div>
          ))}
        </Slider>
 </div>}
  </>
   
  
  );
};

export default CustomerReview;
